import { createSlice } from "@reduxjs/toolkit";
import { CurrentUser } from "./authSlice";

// export interface Users {
//   id: string;
//   role: string;
//   email: string;
// }

export interface UsersState {
  hasFetched: boolean;
  usersList: Array<CurrentUser>;
}

const initialState: UsersState = {
  hasFetched: false,
  usersList: [],
};

export const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setUsers: (state, action) => {
      state.usersList = action.payload;
      state.hasFetched = true;
    },
  },
});

export const { setUsers } = usersSlice.actions;

export default usersSlice.reducer;
